<template>
  <vue-multiselect
    ref="multiselect"
    :model-value="modelValue"
    v-bind="{ ...$attrs, ...$props }"
    @update:model-value="onUpdate" />
</template>

<script setup lang="ts" generic="T">
  import { computed, watch } from 'vue';
  import VueMultiselect from 'vue-multiselect';

  import { LineItem } from '@/common/models';
  import { mapActions } from '@/utils/StateMapping';
  import { ComponentProps } from '@/utils/TypescriptUtils';

  // eslint-disable-next-line
  interface MultiselectProps extends /* @vue-ignore */ ComponentProps<typeof VueMultiselect> {}
  type Props = MultiselectProps & {
    entity: LineItem;
    modelValue: T;
    selectedFeatureKey: string;
    transient?: boolean;
  };
  type Emits = {
    (e: 'update:modelValue', obj: T): void;
  };
  const props = defineProps<Props>();
  const emits = defineEmits<Emits>();
  const { updateLineItemAddFeatureKey, updateLineItemRemoveFeatureKey } = mapActions();

  const isValidEntity = computed(() => props.entity instanceof LineItem);

  function onUpdate(option: T) {
    emits('update:modelValue', option);
  }
  function updateKey(option: T) {
    const value = [
      {
        key: props.selectedFeatureKey,
        transient: props.transient,
      },
    ];
    if (option) {
      updateLineItemAddFeatureKey({
        lineItem: props.entity,
        value,
      });
    } else {
      updateLineItemRemoveFeatureKey({
        lineItem: props.entity,
        value,
      });
    }
  }

  watch(
    () => props.modelValue,
    (val) => {
      if (isValidEntity.value) {
        updateKey(val);
      }
    },
  );
</script>
